import { render, staticRenderFns } from "./serviceManagementEdit.vue?vue&type=template&id=830b2dd6&scoped=true"
import script from "./serviceManagementEdit.vue?vue&type=script&lang=js"
export * from "./serviceManagementEdit.vue?vue&type=script&lang=js"
import style0 from "./serviceManagementEdit.vue?vue&type=style&index=0&id=830b2dd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830b2dd6",
  null
  
)

export default component.exports